import React, { useEffect, useState } from 'react';
import { url } from '../../utils/confserveur';
import TanoEdLogo from '../../assets/logoTanoEd.png';

const Logout = () => {
    const [status, setStatus] = useState('processing'); // 'processing', 'success', 'error'
    const [error, setError] = useState(null);

  
    useEffect(() => {
          const performLogout = async () => {
        try {
           
           localStorage.clear();

            // 2. Appeler l'endpoint de logout backend
            try {
                const response = await fetch(`${url}logout/`, {
                    method: 'POST',
                    credentials: 'include', // Important pour envoyer les cookies
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                const data = await response.json();
              

                // if (data.success) {
                //     console.log('✅ Logout backend réussi');
                // } else {
                //     console.warn('⚠️ Logout backend partiel:', data.message);
                // }
            } catch (backendError) {
                console.error('❌ Erreur logout backend:', backendError);
                // On continue même si le backend échoue
            }

            // 3. Vider manuellement tous les cookies côté client
            clearAllCookies();

            // 4. Vider les données de session du navigateur
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                registrations.forEach(registration => registration.unregister());
            }

            // 5. Vider le cache du navigateur si possible
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(cacheName => caches.delete(cacheName))
                );
                
            }

            setStatus('success');
            
            // 6. Redirection vers login après 2 secondes
            setTimeout(() => {
                // Force un reload complet pour s'assurer que tout est nettoyé
                window.location.href = '/login';
            }, 2000);

        } catch (error) {
            console.error('❌ Erreur lors de la déconnexion:', error);
            setError(error.message);
            setStatus('error');
        }
    };
    performLogout()
    }, []);

  

    const clearAllCookies = () => {
        // Liste de tous les cookies à supprimer
        const cookiesToClear = [
            'access_token',
            'refresh_token',
            'sessionid',
            'csrftoken',
            'oidc_state',
            'oidc_id_token_hint'
        ];

        // Domaines possibles
        const domains = [
            '', // domaine actuel
            '.tanoed.com',
            'pro.tanoed.com',
            '.osc-fr1.scalingo.io',
            'tanoed-pro.osc-fr1.scalingo.io'
        ];

        // Chemins possibles
        const paths = ['/', '/login', '/home', '/oidc'];

        cookiesToClear.forEach(cookieName => {
            domains.forEach(domain => {
                paths.forEach(path => {
                    // Supprimer le cookie avec différentes combinaisons
                    const cookieString = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; ${domain ? `domain=${domain};` : ''} SameSite=None; Secure`;
                    document.cookie = cookieString;
                });
            });
        });

    };

    // Fonction pour forcer un nettoyage complet
    const forceCleanup = () => {
        // Vider tout le localStorage et sessionStorage
        localStorage.clear();
        sessionStorage.clear();
        
        // Essayer de supprimer tous les cookies possibles
        const allCookies = document.cookie.split(';');
        allCookies.forEach(cookie => {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
        });

        // Redirection forcée
        window.location.replace('/login');
    };

    if (status === 'processing') {
        return (
            <div className="min-h-screen fixed inset-0 flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
                <div className="text-center">
                    <div className="mb-6">
                        <img 
                            src={TanoEdLogo}
                            alt="TanoEd Logo" 
                            className="w-24 h-24 mx-auto mb-4"
                        />
                    </div>
                    <div className="relative w-16 h-16 mx-auto mb-6">
                        <div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
                        <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
                    </div>
                    <h2 className="text-xl font-semibold text-blue-800 mb-2">Déconnexion en cours...</h2>
                    <p className="text-blue-600">Nettoyage des données de session</p>
                </div>
            </div>
        );
    }

    if (status === 'success') {
        return (
            <div className="min-h-screen fixed inset-0 flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100">
                <div className="text-center">
                    <div className="mb-6">
                        <img 
                            src={TanoEdLogo}
                            alt="TanoEd Logo" 
                            className="w-24 h-24 mx-auto mb-4"
                        />
                    </div>
                    <div className="mb-6">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-500 rounded-full">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                    </div>
                    <h2 className="text-xl font-semibold text-green-800 mb-2">Déconnexion réussie !</h2>
                    <p className="text-green-600">Redirection vers la page de connexion...</p>
                </div>
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="min-h-screen fixed inset-0 flex items-center justify-center bg-gradient-to-br from-red-50 to-red-100">
                <div className="text-center max-w-md mx-auto p-6">
                    <div className="mb-6">
                        <img 
                            src={TanoEdLogo}
                            alt="TanoEd Logo" 
                            className="w-24 h-24 mx-auto mb-4"
                        />
                    </div>
                    <div className="mb-6">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-500 rounded-full">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                    </div>
                    <h2 className="text-xl font-semibold text-red-800 mb-2">Erreur lors de la déconnexion</h2>
                    <p className="text-red-600 mb-6">{error}</p>
                    <button 
                        onClick={forceCleanup}
                        className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
                    >
                        Forcer la déconnexion
                    </button>
                </div>
            </div>
        );
    }

    return null;
};

export default Logout;